module.exports = __webpack_public_path__ + "media/src/images/icons/fill-checkmark-square-1d60bbc38e3c8080bf7eaa09f2bd1175.svg";